/* eslint-disable @typescript-eslint/naming-convention */
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Brand } from '../models/brand/brand';
import { FileSize } from '../models/file-size/file-size';

export class Statics {
  /** List formatter */
  public static readonly LIST_FORMATTER_CONJUCTION = new (
    Intl as any
  ).ListFormat('nl', {
    style: 'long',
    type: 'conjunction',
  });
  public static readonly LIST_FORMATTER_DISJUNCTION = new (
    Intl as any
  ).ListFormat('nl', {
    style: 'long',
    type: 'disjunction',
  });

  /** File Sizes */
  public static readonly MAX_FILE_SIZES: {
    [key in FileSize]: {
      size: number;
      text: string;
      textMax: string;
    };
  } = {
    normal: {
      size: 52428800,
      text: $localize`50MB`,
      textMax: $localize`Max 50MB`,
    },
    large: {
      size: 157286400,
      text: $localize`150MB`,
      textMax: $localize`Max 150MB`,
    },
  };

  /** Brands */
  public static readonly BRANDS: Brand[] = [
    {
      name: 'Apple',
      icon: 'apple',
      hostnames: ['apple.com'],
    },
    {
      name: 'Bandcamp',
      icon: 'bandcamp',
      hostnames: ['bandcamp.com'],
    },
    {
      name: 'Dailymotion',
      icon: 'dailymotion',
      hostnames: ['dailymotion.com', 'dai.ly'],
    },
    {
      name: 'Deezer',
      icon: 'deezer',
      hostnames: ['deezer.com', 'deezer.page.link'],
    },
    {
      name: 'Facebook',
      icon: 'facebook',
      hostnames: ['facebook.com', 'fb.com'],
    },
    {
      name: 'Flickr',
      icon: 'flickr',
      hostnames: ['flickr.com', 'flic.kr'],
    },
    {
      name: 'Google',
      icon: 'google',
      hostnames: ['google.com', 'g.co'],
    },
    {
      name: 'Instagram',
      icon: 'instagram',
      hostnames: ['instagram.com'],
    },
    {
      name: 'Last.fm',
      icon: 'lastfm',
      hostnames: ['last.fm'],
    },
    {
      name: 'Mixcloud',
      icon: 'mixcloud',
      hostnames: ['mixcloud.com'],
    },
    {
      name: 'Napster',
      icon: 'napster',
      hostnames: ['napster.com'],
    },
    {
      name: 'Patreon',
      icon: 'patreon',
      hostnames: ['patreon.com'],
    },
    {
      name: 'Pinterest',
      icon: 'pinterest',
      hostnames: ['pinterest.com'],
    },
    {
      name: 'Snapchat',
      icon: 'snapchat',
      hostnames: ['snapchat.com'],
    },
    {
      name: 'SoundCloud',
      icon: 'soundcloud',
      hostnames: ['soundcloud.com'],
    },
    {
      name: 'Spotify',
      icon: 'spotify',
      hostnames: ['spotify.com'],
    },
    {
      name: 'TikTok',
      icon: 'tiktok',
      hostnames: ['tiktok.com'],
    },
    {
      name: 'Tumblr',
      icon: 'tumblr',
      hostnames: ['tumblr.com'],
    },
    {
      name: 'Twitch',
      icon: 'twitch',
      hostnames: ['twitch.tv'],
    },
    {
      name: 'Twitter',
      icon: 'twitter',
      hostnames: ['twitter.com', 't.co'],
    },
    {
      name: 'Vimeo',
      icon: 'vimeo',
      hostnames: ['vimeo.com'],
    },
    {
      name: 'WhatsApp',
      icon: 'whatsapp',
      hostnames: ['whatsapp.com', 'wa.me'],
    },
    {
      name: 'Wix',
      icon: 'wix',
      hostnames: ['wixsite.com'],
    },
    {
      name: 'YouTube',
      icon: 'youtube',
      hostnames: ['youtube.com', 'youtu.be'],
    },
  ];

  /** Contextual Menu Positions */
  public static readonly CONTEXTUAL_MENU_POSITIONS: ConnectedPosition[] = [
    {
      offsetX: 8,
      offsetY: 8,
      originX: 'end',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      offsetX: 8,
      offsetY: 8,
      originX: 'start',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top',
    },
    {
      offsetX: 8,
      offsetY: 8,
      originX: 'end',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom',
    },
    {
      offsetX: 8,
      offsetY: 8,
      originX: 'start',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'bottom',
    },
  ];

  /** Dropdown Positions */
  public static readonly DROPDOWN_POSITIONS: ConnectedPosition[] = [
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom',
    },
  ];

  /** Password special characters */
  public static readonly PASSWORD_SPECIAL_CHARACTERS = `= + - ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ \``;
}
